import { Badge } from "@/components/ui/badge"
import type { CaptureStatus } from "@/types"

const statusConfig: Record<CaptureStatus, { label: string; variant: "default" | "secondary" | "destructive" }> = {
  pending: { label: "Pending", variant: "secondary" },
  delivered: { label: "Delivered", variant: "default" },
  failed: { label: "Failed", variant: "destructive" },
}

export function StatusBadge({ status }: { status: CaptureStatus }) {
  const config = statusConfig[status]

  return (
    <Badge variant={config.variant} className={status === "pending" ? "bg-amber-100 text-amber-800 hover:bg-amber-100/80 dark:bg-amber-900/30 dark:text-amber-400" : ""}>
      {config.label}
    </Badge>
  )
}
